"use strict";
var carousel_component_1 = require('./carousel/carousel.component');
exports.CarouselComponent = carousel_component_1.CarouselComponent;
var carousel_module_1 = require('./carousel/carousel.module');
exports.CarouselModule = carousel_module_1.CarouselModule;
var slide_component_1 = require('./carousel/slide.component');
exports.SlideComponent = slide_component_1.SlideComponent;



//////////////////
// WEBPACK FOOTER
// /home/backend/NasheDelo/WebLombard/client/~/ng2-bootstrap/components/carousel.js
// module id = ../../../../ng2-bootstrap/components/carousel.js
// module chunks = 3